import Button from './Button';

export const ErrorState = ({ title = 'Ocurrió un error', message, actionLabel = 'Reintentar', onAction, className = '' }) => {
  return (
    <div className={`text-center py-20 ${className}`}>
      <div className="inline-flex items-center justify-center w-16 h-16 bg-red-100 dark:bg-red-900/20 rounded-full mb-4">
        <svg className="w-8 h-8 text-red-600 dark:text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">{title}</h3>
      {message && <p className="text-gray-600 dark:text-gray-400 mb-6">{message}</p>}
      {onAction && (
        <div className="flex justify-center">
          <Button variant="outline" onClick={onAction}>
            {actionLabel}
          </Button>
        </div>
      )}
    </div>
  );
};

